<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>{{ $t("Login to admin") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-8">
            <v-form ref="form" lazy-validation v-model="valid">
              <field-printer ref="fieldEmail" :field="fieldEmail" v-model="email" @keydown="keydown"></field-printer>
              <field-printer
                ref="fieldPassword"
                :field="fieldPassword"
                v-model="password"
                @keydown="keydown"
              ></field-printer>
              <v-card-actions class="px-0 pb-0">
                <router-link :to="{ name: 'loginForgot' }">{{ $t("Forgot password?") }}</router-link>
                <v-btn color="primary" @click="tryLogin" ref="buttonSubmit" class="ml-auto mr-0">
                  {{ $t("Login") }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FieldPrinter from "@/components/FieldPrinter";
import { $t } from "@/lib/helpers/i18nHelper";
import WithLoadingStatus from "@/mixins/WithLoadingStatus";
import WithLoginData from "@/mixins/WithLoginData";

export default {
  components: { FieldPrinter },
  mixins: [WithLoadingStatus, WithLoginData],
  data() {
    return {
      valid: true,
      email: "",
      password: "",
      fieldEmail: {
        name: "email",
        title: $t("E-mail"),
        rules: [v => !!v || $t("E-mail is required"), v => /.+@.+/.test(v) || $t("E-mail must be valid.")],
      },
      fieldPassword: {
        type: "password",
        name: "password",
        title: $t("Password"),
        rules: [v => !!v || $t("Password is required")],
      },
    };
  },
  methods: {
    async tryLogin() {
      this.$refs.form.validate();
      if (!this.valid) return;

      await this.loginDataLogin({
        email: this.email,
        password: this.password,
      });
      this.$emit("showMenu", null);
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      this.$router.push({ path: "/" }).catch(() => {});
    },
    keydown(e) {
      if (e.key === "Enter") this.tryLogin();
    },
  },
  mounted() {
    this.$refs.fieldEmail.$el.getElementsByTagName("input")[0].focus();
    this.loadingStatusShow([Promise.resolve()]);
  },
};
</script>
